<template>
    <div class="goods" ref="wrapper">
        <div v-if="goodsList.length">
            <van-list
                v-model="loading"
                :finished="finished"
                :finished-text="finishHtml"
                :immediate-check="false"
                @load="onLoad"
            >
            <div class="goodsList" :class="{'bgFFFFFF': toggle}">
                <div class="goodLi" v-for="(item, index) in goodsList" :key="index" @click="onDetail(item.id)" v-show="!toggle">
                    <div class="img" :class="{'hot': item.isHotSale}">
                        <img :src="$viewImageNew(item.imgUrls, 400,400)" alt="">
                    </div>
                    <div class="content">
                        <div class="name">
                            <Tags v-if="item.productTags.length" :tagsArr='item.productTags' />{{ item.name }}
                        </div>
                        <div class="price" v-if="$isPriceShow()">
                            <priceShow
                                :showPrice="item.sellPrice"
                                showPriceColor="#FF7A45"
                                textAlign="left"
                            />
                        </div>
                        <div class="price" v-else>
                            <div style="color: #FF7A45; font-weight: bold">会员价</div>
                        </div>
                        <div class="shopName">{{ item.shopName }}</div>
                    </div>
                </div>
                <div class="goodLi2" v-for="(item, index) in goodsList" :key="index+'_sub'" @click="onDetail(item.id)" v-show="toggle">
                    <div class="img" :class="{'hot': item.isHotSale}">
                        <img v-lazy="$viewImageNew(item.imgUrls, 400,400)" alt="">
                    </div>
                    <div class="content">
                        <div>
                            <div class="name f28 col000">{{ item.name }}</div>
                            <div class="foot" >
                                <div v-if="item.productTags">
                                    <span class="b2" v-for="(it, idx) in item.productTags" :key="idx" :class="{'b1': it === 0}">
                                        <img :src="require('../../../../assets/img/b2b/b'+ parseInt(it+1) +'.png')" alt="">
                                    </span>
                                </div>
                            </div>
                        </div>
                        <priceShow
                            :showPrice="item.sellPrice"
                            showPriceColor="#FF7A45"
                            textAlign="left"
                        >
                        </priceShow>
                    </div>
                </div>
            </div>
            </van-list>
        </div>
        <div class="msg" v-else>
            <img src="../../../../assets/img/b2b/img_empty_order@2x.png" alt="">
            暂无商品
        </div>
        <InvitationCode ref="inCode" @submitCode='init'></InvitationCode>
        <JoinCode ref="inCode2" @submitCode='init'></JoinCode>
    </div>
</template>
<script>
// import { Modal } from '../../api/model.js'
import { Toast } from 'vant'
import InvitationCode from '../../common/InvitationCode'
import priceShow from '../../../common/priceShow'
import Tags from '../../common/Tags'
import JoinCode from '../../common/joinCode'
import { mapActions } from 'vuex'
export default {
    name: 'goods',
    data () {
        return {
            memberCode: '',
            merchantCode: '',
            pageNumber: 1,
            pageSize: 10,
            total: 0,
            finishHtml: '已经到底了',
            finished: false,
            loadShow: false,
            loading: false,
            disClick: true,
            toggle: false,
            goodsList: []
        }
    },
    components: {
        InvitationCode,
        JoinCode,
        priceShow,
        Tags
    },
    methods: {
        ...mapActions(['getProductList']),
        onDetail (id) {
            if (!this.memberCode && !this.merchantCode) {
                this.$refs.inCode.init()
            } else if (this.memberCode && !this.merchantCode) {
                this.$refs.inCode2.init()
            } else {
                localStorage.removeItem('goodsId')
                localStorage.setItem('goodsDetailBack', this.$router.history.current.fullPath)
                this.$router.push({ path: '/b2b/goods/goodsDetail', query: { id: id } })
            }
        },
        onToggle () {
            this.toggle = !this.toggle
        },
        onSubmit (obj) {
            Toast.loading({
                duration: 0,
                message: '加载中...',
                forbidClick: true
            })
            if (!this.disClick) {
                return false
            }
            this.disClick = false
            this.finished = false
            this.pageNumber = 1
            this.pageSize = 10
            this.loading = false
            this.findData = obj
            this.goodsList = []
            this.getFindProductList()
        },
        onLoad () {
            this.pageNumber += 1
            this.getFindProductList()
        },
        async getFindProductList () {
            this.getProductList({
                spuName: this.findData.spuName ? this.findData.spuName : '',
                isHotSale: this.findData.faddish ? this.findData.faddish : '',
                brandIdList: this.findData.brandIds ? this.findData.brandIds : '',
                categoryId: this.findData.categoryId ? this.findData.categoryId : '',
                memberCode: this.memberCode,
                merchantCode: this.merchantCode,
                maxPrice: this.findData.maxPrice ? this.findData.maxPrice : '',
                minPrice: this.findData.minPrice ? this.findData.minPrice : '',
                sortState: this.findData.sortState,
                pageNumber: this.pageNumber,
                pageSize: this.pageSize
            }).then((data) => {
                this.goodsList = this.goodsList.concat(data.records)
                this.loading = false
                this.disClick = true
                if (this.goodsList.length >= data.total) {
                    this.finished = true
                }
                Toast.clear()
            })
        },
        init () {
            this.$router.go(0)
        }
    },
    mounted () {
        let userInfo = JSON.parse(localStorage.getItem('userInfo'))
        this.memberCode = userInfo.companyCode
        this.merchantCode = userInfo.belongMerchantCode
        this.findData = {
            categoryId: this.categoryId,
            brandIds: this.brandId,
            maxPrice: this.maxPrice,
            minPrice: this.minPrice,
            sortState: this.sortPrice
        }
    }
}
</script>
<style lang="scss" scoped>
    .goods{
        .goodsList {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            padding: 0 24px 24px;
            .shaky{
                position: relative;
                margin: 32px 0 20px;
                .title{
                    padding-left: 76px;
                    &.m1::before{
                        position: absolute;
                        top: 6px;
                        left: 0;
                        content: '';
                        width: 56px;
                        height: 28px;
                        background: url(../../../../assets/img/b2b/m1.png) no-repeat;
                        background-size: 100% 100%;
                    }
                    &.m2::before{
                        position: absolute;
                        top: 6px;
                        left: 0;
                        content: '';
                        width: 56px;
                        height: 28px;
                        background: url(../../../../assets/img/b2b/m2.png) no-repeat;
                        background-size: 100% 100%;
                    }
                    h3{
                        margin-bottom: 4px;
                    }
                }
            }
            .goodLi {
                position: relative;
                width: 344px;
                margin-top: 20px;
                background: #ffffff;
                border-radius: 12px;
                overflow: hidden;
                .img {
                    width: 100%;
                    height: 344px;
                    position: relative;
                    display: flex;
                    background-color: #FAFAFA;
                    img{
                        display: inline-block;
                        margin: 0 auto;
                        background: #f2f3f5;
                        object-fit: cover;
                        align-self: center;
                        justify-self: center;
                    }
                }
                .content {
                    padding: 18px 24px 12px 16px;
                    .name {
                        height: 80px;
                        font-size: 28px;
                        line-height: 40px;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                        white-space: normal;
                        word-break: break-all;
                    }
                    .price {
                        margin-top: 10px;
                    }
                    .shopName {
                        margin-top: 12px;
                        font-size: 22px;
                        color: #999;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 1;
                        overflow: hidden;
                        white-space: normal;
                        word-break: break-all;
                    }
                }
            }
            .goodLi2 {
                position: relative;
                display: flex;
                justify-content: flex-start;
                margin: 24px 0;
                width: 100%;
                .img{
                    flex: 0 0 256px;
                    font-size: 0;
                    background-color: #FAFAFA;
                    img{
                        border-radius: 12px;
                        display: inline-block;
                        height: 256px;
                        margin: 0 auto;
                        align-self: center;
                        justify-self: center;
                        background: #f2f3f5;
                        object-fit: cover;
                    }
                }
                .content{
                    flex: 1;
                    margin-left: 24px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    .name {
                        font-size: 28px;
                        line-height: 40px;
                        margin: 16px 0;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                        white-space: normal;
                        word-break: break-all;
                    }
                    .foot {
                        span{
                            display: inline-block;
                            margin-right: 8px;
                            &.b2{
                                width: 64px;
                                height: 32px;
                            }
                            &.b1{
                                width: 42px;
                                height: 32px;
                            }
                        }
                    }
                    .price{
                        font-size: 30px;
                        sub{
                            font-size: 20px;
                        }
                    }
                }
            }
        }
        .loading {
            color: #999;
            text-align: center;
            padding: 40px;
        }
        .msg {
            width: 182px;
            font-size: 26px;
            color: #c7c7cc;
            margin: 0 auto;
            padding-top: 160px;
            text-align: center;
            img {
                width: 176px;
                height: 176px;
                margin: 0 auto;
            }
        }
    }
</style>
